/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OfInputs */

const en_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of`)
};

const es_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de`)
};

const fr_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sur`)
};

const de_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`von`)
};

const ja_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/`)
};

const zh_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/`)
};

const ar_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من`)
};

const id_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari`)
};

const it_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di`)
};

const ru_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`из`)
};

const pt_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de`)
};

const ko_of = /** @type {(inputs: OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/`)
};

/**
* | output |
* | --- |
* | "of" |
*
* @param {OfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const of = /** @type {((inputs?: OfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_of(inputs)
	if (locale === "es") return es_of(inputs)
	if (locale === "fr") return fr_of(inputs)
	if (locale === "de") return de_of(inputs)
	if (locale === "ja") return ja_of(inputs)
	if (locale === "zh") return zh_of(inputs)
	if (locale === "ar") return ar_of(inputs)
	if (locale === "id") return id_of(inputs)
	if (locale === "it") return it_of(inputs)
	if (locale === "ru") return ru_of(inputs)
	if (locale === "pt") return pt_of(inputs)
	return ko_of(inputs)
});